module.exports = __webpack_public_path__ + "img/c_v5.d448cab.png";